import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "./Featured.css";

import fragrance from "../../Images/fragrances_cover.jpg";
import facewash from "../../Images/facewash_cover.jpg";
import neem from "../../Images/neem_cover.jpg";
import shampoo from "../../Images/shampoo.png";
import { Link } from "react-router-dom";
import leaf7 from "../../Images/leaf7.png";
import leaf6 from "../../Images/leaf6.png";

const Featured = () => {
  return (
    <div>
      <div className="bg-sec flex flex-col items-center px-[10px] py-10 mx-auto relative">
        {/* Decorative leaf for design only */}
          {/* <img
            className="absolute w-[120px] lg:w-[350px] right-0 lg:right-[-60px] top-[40%] fa-rotate-270 hidden sm:block"
            alt="Decorative leaf element for Clariss section"
            src={leaf6}
            loading="lazy"
          /> */}

        {/* ✅ SEO-friendly heading */}
        <h4 className="text-center">
          <span className="text-accent text-4xl font-bold">EMBRACE</span>{" "}
          <span className="text-secondary ms-2 text-4xl font-bold">BEAUTY</span>
        </h4>

        {/* ✅ Secondary heading for better keyword targeting */}
        <p className="text-center text-accent font-bold text-2xl mt-4">
          A Cruelty-Free Collection of Natural Beauty Products
        </p>

        {/* ✅ Featured product grid */}
        <div className="flex flex-row flex-wrap mx-auto w-[96%] 2xl:w-[1200px] mt-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {/* Neem Face Wash */}
            <Link to="/product/clariss-neem-face-wash" className="group">
              <img
                alt="Clariss Neem Face Wash – natural cleansing solution"
                src={neem}
                className="w-[100%] cursor-pointer animated-element"
                loading="lazy"
                title="Clariss Neem Face Wash"
              />
              <span className="sr-only">
                Explore Clariss Neem Face Wash – ideal for gentle skin care
              </span>
            </Link>

            {/* Shampoo */}
            <Link to="/product-category/shampoo" className="group">
              <img
                alt="Clariss Shampoo – nourishing hair care"
                src={shampoo}
                className="w-[100%] cursor-pointer animated-element"
                loading="lazy"
                title="Clariss Shampoo Collection"
              />
              <span className="sr-only">
                Browse Clariss natural shampoos for healthy, shiny hair
              </span>
            </Link>

            {/* Face Wash Collection */}
            <Link to="/product-category/face wash" className="group">
              <img
                alt="Clariss Face Wash Collection – for clean and glowing skin"
                src={facewash}
                className="w-[100%] cursor-pointer animated-element"
                loading="lazy"
                title="Clariss Face Wash Collection"
              />
              <span className="sr-only">
                Discover Clariss Face Wash range for all skin types
              </span>
            </Link>

            {/* Fragrances */}
            <Link to="/product-category/fragrances" className="group">
              <img
                alt="Clariss Fragrances – premium scents"
                src={fragrance}
                className="w-[100%] cursor-pointer animated-element"
                loading="lazy"
                title="Clariss Fragrances Collection"
              />
              <span className="sr-only">
                Explore Clariss perfumes and fragrances for a long-lasting scent
              </span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Featured;
